import React, { useRef } from 'react';
import { useClickAway } from 'react-use';
import { StyledSocialSignupModal } from './styled'

export const SocialSignupModal: React.FC<{ onClose: () => void }> = ({ onClose }) => {
  const modalRef = useRef<HTMLDivElement>(null);
  const handleClickOutside = () => onClose()
  useClickAway(modalRef, handleClickOutside)

  return (
    <div ref={modalRef}>
      <StyledSocialSignupModal />
    </div>
  );
};
